<!--
    @name: 记工记账
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-09-23 11:49:18
-->
<template>
  <div class="page">
    <div style="margin-bottom: 20px">
      <el-select v-model="projectid" placeholder="暂无项目" @change="getworkRecords">
        <el-option v-for="(item,i) in projectlist" :key="i" :label="item.projectName" :value="i"/>
      </el-select>
      <projectManagement ref="projectManagement" @change="getprojectlist()" @upNo="upNo"></projectManagement>
      <WorkerManagement v-if="type==2" ref="wordkrManagement" @change="getprojectlist()" @upNo="upNo"></WorkerManagement>
    </div>
    <el-row :gutter="5" v-if="showPage">
      <el-col :span="14" class="context" style="width: 608px">
        <div class="c_title">
          <span class="c_t_left">{{year}}年{{math}}月</span>
          <el-select v-model="year" placeholder="年" @change="getworkRecords" style="margin-right: 10px">
            <el-option v-for="item in yeararr" :key="item" :label="item+'年'" :value="item"/>
          </el-select>
          <el-select v-model="math" placeholder="月" @change="getworkRecords">
            <el-option v-for="item in 12" :key="item" :label="item+'月'" :value="item"/>
          </el-select>
          <span style="width: 80px;display: inline-block">
            <statisticsBtn ref="statisticsBtn" :project="projectlist[projectid]" @close="btnclose"/>
          </span>

        </div>
        <Calendar :year="year" :math="math" @clickday="clickday">
          <div slot-scope="{data}" style="font-size: 12px;color: #FF6600;margin-left: 5px;height: 1em">
            {{workRecordsobj[`0${data.cDay}`.substr(-2)]}}
          </div>
        </Calendar>
      </el-col>
      <el-col :span="10" style="margin-left: 10px;padding: 0;width: 542px">
        <!--    当前项目详情面板    -->
        <statisticsList ref="statisticsList" :project="projectlist[projectid]"/>
      </el-col>
    </el-row>
    <DayLogLists v-if="type==2" ref="dayLogList"></DayLogLists>
    <dayLogList v-else ref="dayLogList"></dayLogList>
  </div>
</template>

<script>
import {api} from '@/api/apiRecord.js'
export default {
  name: "record",
  components:{
    Calendar: () => import("@/components/Calendar"),
    projectManagement: () => import("./components/projectManagement"),
    WorkerManagement: () => import("./components/worker-management/WorkerManagement"),
    dayLogList: () => import("./components/dayLogList"),//个人记工列表
    DayLogLists: () => import("./components/DayLogLists"),//班组记工列表
    statisticsBtn: () => import("./components/statistics/statisticsBtn"),//记工按钮
    statisticsList: () => import("./components/statistics/statisticsList"),//记工列表
  },
  data(){
    return {
      year:2021,
      math:9,
      projectid:'',
      page:{
        limit:100,
        page:1
      },
      projectlist:[],
      workRecordsobj:{},
      yeararr:[],//日期下拉
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
      showPage:true
    }
  },
  created(){
    let arr=[];
    let i=1970;
    while (i<=new Date().getFullYear()){
      arr.push(i++)
    }
    this.yeararr=arr
    let date=new Date();
    this.year=date.getFullYear();
    this.math=date.getMonth()+1;
  },
  mounted(){
    this.getprojectlist();
  },
  methods:{
    //获取项目列表
    async getprojectlist(projectNo){
      let res=await api.getProjectPage({...this.page,type:this.type});
      if(res.data.code==200){
        this.projectlist=res.data.data.records;
        if(!this.projectlist.length){
          this.workRecordsobj={}
          this.showPage=false
          this.$nextTick(()=>{
            this.showPage=true
          })
        }
      }
      if(projectNo){
        this.projectlist.forEach((v,i)=>{
          if(v.no==projectNo){
            this.projectid=i;
          }
        })
      }else{
        this.projectid=this.projectlist.length?0:'';
      }
      this.getworkRecords();
    },
    //获取项目月份数据
    async getworkRecords(type=false){
      if(this.$refs.dayLogList&&this.$refs.dayLogList.show){
        this.$refs.dayLogList.getList();
      }
      if(!this.projectlist[this.projectid])return;
      let obj={
        projectNo:this.projectlist[this.projectid].no,
        year:this.year,
        month:`0${this.math}`.substr(-2),
        type:this.type,
      }
      let res=await api.workRecords(obj);

      if(res.data.code==200){
        let workRecords={};
        res.data.data.map(v=>{
          let k=v.recordDate.split('-')[2];
          if(!workRecords[k])workRecords[k]= {workDuration:0.00,workDuration4:0.00}
          if(v.workType==3){
            if(v.haveWorkOvertime==2)workRecords[k].jb=true;//='加班'
            else workRecords[k].gg=true;
          }else{
            if(v.recordType==2){
              workRecords[k].bg=true;//='包工';
            }else if(v.recordType==1){
              workRecords[k].gg=true;//='个工';
                if(v.workType<3)workRecords[k].workDuration+=+v.workDuration;//workType 时长类型(1按一个工,2按输入工天,3:休息,4:按小时)
              if(v.workType==4)workRecords[k].workDuration4+=+v.workDuration;//只统计小时
            }
          }
        });
        Object.keys(workRecords).forEach(k=>{
          let end=false;
          if(workRecords[k].gg){
            if(workRecords[k].workDuration)workRecords[k]=workRecords[k].workDuration.toFixed(1)+'个工';
            end=true;
          }
          if(workRecords[k].bg)workRecords[k]='包工';
          else if(workRecords[k].jb)workRecords[k]='加班';
          if(typeof workRecords[k] != 'string'){
            if(workRecords[k].workDuration4)workRecords[k]=workRecords[k].workDuration4.toFixed(1)+'小时'
            else workRecords[k]='休息'
          }

        })
        this.workRecordsobj=workRecords;
        //继续加载右边项目详情
        setTimeout(()=>{
          this.$refs.statisticsList.getList(obj.projectNo)
        },this.$refs.statisticsList.$refs.waterRef?0:300)
      }
    },
    //日期点击
    clickday(obj){
      let v={...obj};
      v.cDay=`0${v.cDay}`.substr(-2)
      if(this.workRecordsobj[v.cDay]){
        let dayobj={
          ...v,
          projectNo:this.projectlist[this.projectid].no
        }
        this.$refs.dayLogList.open(dayobj);
        return;
      }
      if(!this.projectlist.length){
        this.$refs.projectManagement.$refs.projectEdit.open()
      }else{
        this.$refs.statisticsBtn.day=v;
        this.$refs.statisticsBtn.selectStatisticsType=true;
      }
    },
    //子弹窗中变更项目id时
    upNo(no){
      this.projectlist.forEach((v,i)=>{
        if(v.no==no){
          if(this.projectid!=i){
            this.projectid=i;
            this.getworkRecords();
          }
        }
      })
    },
    //记工按钮中弹窗关闭时
    btnclose(projectNo=''){
      if(projectNo){
        this.getprojectlist(projectNo);
      }else{
        this.getworkRecords();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page{
    box-sizing: border-box;
    margin: 10px auto;
    padding: 20px;
    width: 1200px;
    background: #fff;
    .context{
      border: #B79255 1px solid;
      border-radius:7px;
      padding: 30px 20px !important;
      .c_title{
        text-align: right;
        margin-bottom: 20px;
        .c_t_left{
          float: left;
          font-size: 24px;
          line-height: 40px;
        }
        .el-select{
          width: 120px;
        }
      }
    }
    /deep/.el-button--default{
      color: #B79255 !important;
      border-color:#B79255 !important;
      &:hover{
        color: #B79255 !important;
        background: #fff;
        border-color:#B79255 !important;
      }
    }
    // /deep/.el-button--primary{
    //   background: #B79255 !important;
    //   border-color:#B79255 !important;
    //   color: #fff!important;
    // }
  }
</style>
<!--
 appendbody的弹窗只能全局改样式
-->
<style lang="scss" scoped>
  .el-dialog__body{
    border-top: 1px solid #E4E7ED;
  }
  .el-dialog{
    .el-dialog__header{
      padding: 15px 20px;
    }
    .el-button--default{
      color: #969696;
      background: #fff;
      border-color:#E4E7ED !important;
      &:hover{
        color: #B79255 !important;
        background: #fff;
        border-color:#B79255 !important;
      }
    }
    /deep/.el-button--primary{
      background: #B79255 !important;
      border-color:#B79255 !important;
      color: #fff!important;
        &:hover,&:focus{
          color: #fff;
          border-color: #b79255;
          background: #b79255;
          }
    }
  }

</style>
